import { render, staticRenderFns } from "./ElectronicElectrician.vue?vue&type=template&id=323da028&scoped=true&"
import script from "./ElectronicElectrician.vue?vue&type=script&lang=js&"
export * from "./ElectronicElectrician.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicElectrician.vue?vue&type=style&index=0&id=323da028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323da028",
  null
  
)

export default component.exports